<div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title">{{ data.title }}</h4>
    <div mat-dialog-content class="dialog-content text-muted">
        <p class="mb-3">
            To proceed with using Employee Management, please confirm your password below.
        </p>
        <div *ngIf="msg" class="w-100 text-center text-danger mb-2">
            <p>{{ msg }}</p>
        </div>
        <form [formGroup]="passForm" class="col-12">
            <div class="row p-0">
                <mat-form-field class="col-12" appearance="outline">
                    <mat-label>Confirm Password</mat-label>
                    <input matInput [type]="hidePassword ? 'password' : 'text'" placeholder="Confirm your password."
                        formControlName="password" required>
                    <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword"
                        [attr.aria-label]="'Toggle password visibility'" [attr.aria-pressed]="!hidePassword"
                        type="button">
                        <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>

                    <mat-error *ngIf="passForm.get('password')?.hasError('required')">
                        Password is required.
                    </mat-error>
                </mat-form-field>
            </div>
        </form>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-4 d-flex align-items-center justify-content-end">
        <button mat-button class="cancel-button" (click)="onNoClick()">{{data.cancelText}}</button>
        <button mat-button class="btn btn-success yes-button" [disabled]="passForm.invalid" (click)="save()"
            *ngIf="!isLoading; else loadingTemplate" cdkFocusInitial>{{data.confirmText}}</button>
        <ng-template #loadingTemplate>
            <button mat-button class="btn btn-success yes-button" cdkFocusInitial disabled>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>
        </ng-template>
    </div>
</div>